import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '@/core/layout/service/layout.service';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RippleModule } from 'primeng/ripple';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, InputTextModule, ButtonModule, IconFieldModule, InputIconModule, RippleModule],
    template: ` <div
        class="layout-topbar"
        [ngClass]="{
            'border-b-0': layoutService.layoutConfig().topbarTheme !== 'light'
        }"
    >
        <div class="layout-topbar-start">
            <a class="layout-topbar-logo" routerLink="/">
                <img src="/images/logo/top-bar-logo.png" alt="" />
                <span class="text-3xl font-extrabold ml-3">Skill Dukez</span>
            </a>
            <a #menuButton class="layout-menu-button" (click)="onMenuButtonClick()" pRipple>
                <i class="pi pi-angle-right"></i>
            </a>
        </div>

        <div class="layout-topbar-end">
            <div class="layout-topbar-actions-end">
                <ul class="layout-topbar-items">
                    <!--                    <li>-->
                    <!--                        <button class="app-config-button" (click)="onConfigSidebarToggle()">-->
                    <!--                            <i class="pi pi-palette"></i>-->
                    <!--                        </button>-->
                    <!--                    </li>-->
                </ul>
            </div>
        </div>
    </div>`
})
export class AppTopbarComponent {
    @ViewChild('menuButton') menuButton!: ElementRef;

    @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;
    activeItem!: number;
    layoutService: LayoutService = inject(LayoutService);

    constructor(public el: ElementRef) {}

    get mobileTopbarActive(): boolean {
        return this.layoutService.layoutState().topbarMenuActive;
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onMobileTopbarMenuButtonClick() {
        this.layoutService.onTopbarMenuToggle();
    }

    onConfigSidebarToggle() {
        this.layoutService.showConfigSidebar();
    }
}
